import GoalError from './GoalError';
class GoalIsAlreadyDeactivated extends GoalError {
    constructor(goalId, options) {
        super(`The goal with id ${goalId} is deactivated`, options);
    }
}
export default GoalIsAlreadyDeactivated;
